import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { identifyUser, resetAnalytics } from '@/lib/analytics';
import { router } from './router';

/** Keeps the PostHog person in sync with the Clerk session. */
function AnalyticsIdentity() {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn && user) {
      identifyUser(user.id, user.primaryEmailAddress?.emailAddress);
    } else {
      resetAnalytics();
    }
  }, [isLoaded, isSignedIn, user]);

  return null;
}

function App() {
  return (
    <>
      <AnalyticsIdentity />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
